import React, { useState } from "react";
import styles from "./attribute-name-value.module.scss";

interface AttributeNameValueProps {
  name: string;
  value: string;
}

export const AttributeNameValue = ({
  name,
  value,
}: AttributeNameValueProps) => {
  const cssClassName = "attribute-name-value";
  const isLogOutput = name.replace(/:$/, "") === "Log output";
  const [isExpanded, setIsExpanded] = useState(false);
  const valueLines = value.split("\n");
  const hasMoreLines = isLogOutput && valueLines.length > 4;
  const visibleValue =
    hasMoreLines && !isExpanded ? valueLines.slice(0, 4).join("\n") : value;

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__attribute-name`]}>{name}</div>
      <div className={styles[`${cssClassName}__attribute-value`]}>
        {visibleValue}
      </div>
      {hasMoreLines && (
        <button
          type="button"
          className={styles[`${cssClassName}__expand-button`]}
          onClick={() => setIsExpanded((expanded) => !expanded)}
        >
          {isExpanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};
